import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container } from 'reactstrap';

const ClientCounter = (props) => {
    const counts = props?.data;
    // const [animatedCounts, setAnimatedCounts] = useState(counts.map(({ value }) => 0));

    const [animatedCounts, setAnimatedCounts] = useState(
        counts.map(() => 0)
    );

    useEffect(() => {
        const duration = 2000; // 2 seconds
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1); // 0 → 1

            setAnimatedCounts(
                counts.map(({ value }) => Math.round(value * progress))
            );

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }, [counts]);

    return (
        <section className="client-counter">
            <Container className="page-warper">
                <Card className="p-4 mt-4">
                    <CardBody className="p-4">
                        <div className="d-flex no-block gap-1 justify-content-between">
                            {counts?.map((count, index) => (
                                <div key={count.id} className="display-7 text-center">
                                    <h1 className="m-0">
                                        {index === 3 ? `${animatedCounts[index]}%` : animatedCounts[index] > 10 ? animatedCounts[index] : `0${animatedCounts[index]}`}
                                    </h1>
                                    <span>{count.label}</span>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </section>
    );
}

export default ClientCounter;
